import { Spinner } from "@thetreep/ui";
import { t } from "i18next";
import { Trans } from "react-i18next";

interface ContactMethodsProps {
  agencyName: string;
  phoneNumber: string;
  email: string;
  openHours: string;
  isChatEnabled: boolean;
}

export function ContactMethods({
  agencyName,
  phoneNumber,
  email,
  openHours,
  isChatEnabled,
}: ContactMethodsProps) {
  function isFreshChatEnabled() {
    return localStorage.getItem("cookie-accepted") === "true";
  }

  const trimmedHours = openHours.trim();

  const contactOptions = [
    agencyName &&
      phoneNumber && {
        title: t("contact.phoneTitle"),
        description: (
          <>
            <Trans
              t={t}
              values={{
                agencyName: agencyName,
                phoneNumber: phoneNumber,
                openHours: trimmedHours ? ` (${trimmedHours})` : "",
              }}
            >
              contact.phoneDescription
            </Trans>
          </>
        ),
        svg: (
          <svg
            width="79"
            height="78"
            viewBox="0 0 79 78"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_8812_345)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M27.0592 51.4443C39.5555 63.9405 51.1352 65.3088 54.5347 65.4355C58.6427 65.585 62.8352 62.231 64.6487 58.7958C61.7562 55.4028 57.9895 52.7703 53.8652 49.9168C51.431 52.3478 48.4312 56.8653 44.437 55.2468C42.1652 54.3335 36.5557 51.7498 31.6547 46.8455C26.7505 41.9445 24.17 36.335 23.2502 34.0665C21.6317 30.0658 26.1622 27.0595 28.5965 24.6253C25.743 20.4328 23.156 16.5685 19.7695 13.8223C16.2855 15.6423 12.912 19.8023 13.0647 23.9655C13.1915 27.365 14.5597 38.9448 27.0592 51.4443ZM54.2942 71.9323C49.6142 71.76 36.351 69.927 22.4605 56.0398C8.57324 42.1493 6.74349 28.8893 6.56799 24.206C6.30799 17.069 11.7745 10.1368 18.0892 7.42953C18.8497 7.10117 19.6824 6.97616 20.5057 7.06675C21.329 7.15734 22.1147 7.46043 22.7855 7.94628C28.0115 11.7585 31.6157 17.5338 34.713 22.0578C35.3573 22.9985 35.6525 24.1349 35.5474 25.2702C35.4424 26.4056 34.9437 27.4685 34.1377 28.275L29.7307 32.6853C30.7545 34.944 32.8377 38.8375 36.2502 42.25C39.6627 45.6625 43.5562 47.7458 45.8182 48.7695L50.222 44.3625C51.0316 43.5549 52.099 43.0569 53.2381 42.9553C54.3771 42.8538 55.5157 43.1551 56.4555 43.8068C61.0705 47.0048 66.4915 50.557 70.4435 55.6173C70.9688 56.293 71.3029 57.0974 71.411 57.9464C71.519 58.7954 71.397 59.6578 71.0577 60.4435C68.3375 66.7908 61.454 72.1955 54.2942 71.9323Z"
                fill="#0C419A"
              />
            </g>
            <defs>
              <clipPath id="clip0_8812_345">
                <rect
                  width="78"
                  height="78"
                  fill="white"
                  transform="translate(0.5)"
                />
              </clipPath>
            </defs>
          </svg>
        ),
      },
    agencyName &&
      isChatEnabled &&
      isFreshChatEnabled() && {
        title: t("contact.chatTitle"),
        description: (
          <>
            <Trans
              t={t}
              values={{
                agencyName: agencyName,
              }}
            >
              contact.chatDescription
            </Trans>
          </>
        ),
        svg: (
          <svg
            width="79"
            height="78"
            viewBox="0 0 79 78"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_8812_759)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.5001 39C13.4967 33.7178 15.3314 28.5991 18.6896 24.5218C22.0478 20.4446 26.7201 17.6629 31.905 16.6541C37.0899 15.6452 42.4643 16.472 47.1063 18.9926C51.7482 21.5133 55.3684 25.5706 57.3458 30.4687C57.673 31.262 58.3007 31.8937 59.0919 32.226C59.8831 32.5583 60.7736 32.5642 61.5691 32.2424C62.3646 31.9205 63.0005 31.2972 63.3382 30.5083C63.6758 29.7193 63.6877 28.8289 63.3713 28.0312C61.868 24.2829 59.605 20.8864 56.7248 18.0555C53.8446 15.2246 50.4096 13.0205 46.6359 11.5821C42.8622 10.1437 38.8316 9.50207 34.7978 9.69758C30.764 9.89309 26.8144 10.9215 23.1975 12.7182C19.5806 14.5148 16.3748 17.0407 13.7819 20.1369C11.189 23.2331 9.26507 26.8325 8.1313 30.7087C6.99753 34.5848 6.67843 38.6536 7.19409 42.6591C7.70976 46.6646 9.04902 50.5199 11.1276 53.9825L8.59257 62.5917C8.42594 63.1566 8.41469 63.756 8.55999 64.3268C8.70529 64.8975 9.00178 65.4186 9.41825 65.835C9.83471 66.2515 10.3558 66.548 10.9265 66.6933C11.4973 66.8386 12.0967 66.8274 12.6616 66.6607L21.2741 64.1257C24.7379 66.1976 28.5952 67.5258 32.6003 68.0257C33.4558 68.1326 34.3187 67.8953 34.9992 67.3659C35.6797 66.8366 36.1221 66.0586 36.2289 65.2031C36.3358 64.3476 36.0985 63.4847 35.5691 62.8042C35.0398 62.1237 34.2618 61.6813 33.4063 61.5745C30.0744 61.1596 26.8768 60.0072 24.0463 58.201C23.4877 57.8435 22.8591 57.6098 22.2026 57.5157C21.5461 57.4215 20.8771 57.469 20.2406 57.655L16.4966 58.7567L17.5983 55.0127C17.9883 53.6867 17.7511 52.3022 17.0523 51.2102C14.7253 47.5634 13.4926 43.3259 13.5001 39ZM65.5001 53.625C65.4998 51.101 64.6601 48.6488 63.1132 46.6544C61.5663 44.66 59.4 43.2368 56.9554 42.6088C54.5108 41.9808 51.9267 42.1837 49.6101 43.1855C47.2934 44.1873 45.3758 45.9312 44.159 48.1425C42.9423 50.3539 42.4956 52.9071 42.8893 55.4002C43.2829 57.8933 44.4946 60.1847 46.3335 61.9135C48.1724 63.6424 50.5341 64.7105 53.0467 64.9498C55.5593 65.1891 58.0802 64.5859 60.2123 63.2352C61.0901 62.6768 62.1475 62.4735 63.1698 62.6665C62.9759 61.6446 63.1781 60.5872 63.7353 59.709C64.8911 57.8905 65.5034 55.7797 65.5001 53.625ZM54.1251 35.75C57.2307 35.7497 60.2827 36.5586 62.9805 38.0969C65.6784 39.6352 67.9288 41.8499 69.5103 44.5227C71.0917 47.1954 71.9495 50.2341 71.9991 53.3393C72.0488 56.4445 71.2885 59.509 69.7933 62.231L71.0478 66.4917C71.2137 67.0548 71.2247 67.6522 71.0798 68.221C70.9348 68.7898 70.6393 69.3091 70.2242 69.7241C69.8092 70.1392 69.2899 70.4347 68.7211 70.5797C68.1523 70.7246 67.5549 70.7136 66.9918 70.5477L62.7343 69.2932C60.3454 70.605 57.6881 71.3531 54.9657 71.4805C52.2433 71.6078 49.5278 71.1109 47.0269 70.0278C44.526 68.9446 42.3059 67.304 40.5363 65.2313C38.7667 63.1585 37.4945 60.7086 36.8169 58.0688C36.1394 55.4289 36.0745 52.6691 36.6271 50.0004C37.1797 47.3316 38.3353 44.8245 40.0055 42.6709C41.6756 40.5172 43.8162 38.774 46.2634 37.5744C48.7106 36.3749 51.3997 35.7508 54.1251 35.75Z"
                fill="#0C419A"
              />
            </g>
            <defs>
              <clipPath id="clip0_8812_759">
                <rect
                  width="78"
                  height="78"
                  fill="white"
                  transform="translate(0.5)"
                />
              </clipPath>
            </defs>
          </svg>
        ),
      },
    email && {
      title: t("contact.emailTitle"),
      description: (
        <>
          <Trans
            t={t}
            values={{
              email: email,
            }}
          >
            contact.emailDescription
          </Trans>
        </>
      ),
      svg: (
        <svg
          width="79"
          height="78"
          viewBox="0 0 79 78"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_8812_351)">
            <path
              d="M65.5 13C67.1399 12.9995 68.7193 13.6188 69.9218 14.7339C71.1242 15.8489 71.8608 17.3772 71.9837 19.0125L72 19.5V58.5C72.0005 60.1399 71.3812 61.7193 70.2661 62.9218C69.1511 64.1242 67.6228 64.8608 65.9875 64.9838L65.5 65H13.5C11.8601 65.0005 10.2807 64.3812 9.07822 63.2661C7.87578 62.1511 7.13924 60.6228 7.01625 58.9875L7 58.5V19.5C6.99948 17.8601 7.61882 16.2807 8.73387 15.0782C9.84891 13.8758 11.3772 13.1392 13.0125 13.0163L13.5 13H65.5ZM65.5 24.0955L42.945 46.6505C42.0309 47.5634 40.7919 48.0762 39.5 48.0762C38.2081 48.0762 36.9691 47.5634 36.055 46.6505L13.5 24.0955V58.5H65.5V24.0955ZM60.9045 19.5H18.0955L39.5 40.9045L60.9045 19.5Z"
              fill="#0C419A"
            />
          </g>
          <defs>
            <clipPath id="clip0_8812_351">
              <rect
                width="78"
                height="78"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    },
  ].filter(Boolean);

  const isLoading = contactOptions.length === 0;

  if (isLoading) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div
      className={`grid grid-cols-1 md:grid-cols-${contactOptions.length} gap-6 p-6 rounded-lg`}
    >
      {contactOptions.map((option, index) => (
        <div
          key={index}
          className="flex flex-col justify-start items-center text-center bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition"
        >
          <p className="mt-8">{option && option.svg}</p>
          <h2 className="text-blue-medium text-2xl h-10 mt-4 flex items-center justify-center">
            {option && option.title}
          </h2>
          <p className="text-sm text-gray-700 mt-4">
            {option && option.description}
          </p>
        </div>
      ))}
    </div>
  );
}
